import React from 'react'
import {Input} from '@salesforce/design-system-react'

const CustomDisplay = ({id, label, value}) => {
  return (
    <div className="slds-p-top_x-small form-item">
      <Input
        id={id}
        label={label}
        value={value}
        disabled={true}
      />
    </div>
  )
}

CustomDisplay.defaultProps = {
  id: 'display-1',
  label: 'REPLACE-custom-display-label',
  value: ''
}

export default CustomDisplay
